<template>
  <div class="page-config-live-data">
    <!-- Mobile plant selector trigger -->
    <div class="d-md-none px-2 pt-2">
      <button class="btn btn-outline-secondary w-100 mb-2" @click="mobilePlantSelectorOpen = true">
        <i class="bi bi-list me-1"></i>
        Anlage wählen
      </button>
    </div>

    <!-- Mobile offcanvas bottom sheet -->
    <div
      v-if="mobilePlantSelectorOpen"
      class="offcanvas offcanvas-bottom d-md-none show"
      style="height: 65vh; visibility: visible"
      tabindex="-1"
    >
      <div class="offcanvas-header">
        <h5 class="offcanvas-title">Anlage wählen</h5>
        <button type="button" class="btn-close" @click="mobilePlantSelectorOpen = false"></button>
      </div>
      <div class="offcanvas-body overflow-auto">
        <NavPlantsSidebar
          v-if="plantsLoaded"
          v-bind="currentPlantsProperties"
          v-on:setPlant="onMobilePlantSelected"
          v-on:setComponent="onMobileComponentSelected"
        />
      </div>
    </div>
    <div
      v-if="mobilePlantSelectorOpen"
      class="offcanvas-backdrop fade show"
      @click="mobilePlantSelectorOpen = false"
    ></div>

    <div class="col-md-3 col-lg-2 d-none d-md-block bg-light sidebar">
      <NavPlantsSidebar
        v-if="plantsLoaded"
        v-bind="currentPlantsProperties"
        v-on:setPlant="setResearchPlant"
        v-on:setComponent="setResearchPlantComponent"
      ></NavPlantsSidebar>
    </div>
    <div class="col-md-9 ms-sm-auto col-lg-10 my-2">
      <div class="row">
        <div class="col-12 col-md-4 mb-3">
          <ChooseDataResearch
            v-if="this.currentPlantComponent"
            v-bind="currentProperties"
            v-on:updateChoosenData="updateChoosenData"
          ></ChooseDataResearch>
        </div>
        <div class="col-12 col-md-4 mb-3">
          <template v-if="this.allCheckedPlantComponentDescriptions.length > 0">
            <ListAllChoosenData
              v-bind="propertiesListChoosenData"
              v-on:removeDescription="removeDescription"
            ></ListAllChoosenData>
          </template>
          <template v-else>
            {{ $t('research_how_to') }}
          </template>
        </div>
        <div class="col-12 col-md-4 mb-3">
          <ChooseDateRange
            v-if="this.allCheckedPlantComponentDescriptions.length > 0"
            v-on:confirmDate="confirmDate"
          ></ChooseDateRange>
        </div>
      </div>
      <div class="row my-3">
        <VisualizeResearchData
          v-if="this.allCheckedPlantComponentDescriptions.length > 0"
          v-bind="visualizeProperties"
          v-on:generateExcel="generateExcel"
        ></VisualizeResearchData>
      </div>
    </div>
  </div>
</template>

<script>
import VisualizeResearchData from '@/components/research/VisualizeResearchData.vue';
import ChooseDateRange from '@/components/research/ChooseDateRange.vue';
import ListAllChoosenData from '@/components/research/ListAllChoosenData.vue';
import ChooseDataResearch from '@/components/research/ChooseDataResearch.vue';
import NavPlantsSidebar from '@/components/navs/NavPlantsSidebar.vue';
import { createToast } from '@/assets/js/myToast.js';
import apiClient from '@/services/apiClient';

const fileDownload = require('js-file-download');
/* eslint-disable vue/multi-word-component-names */
export default {
  name: 'Research',
  components: {
    VisualizeResearchData,
    ChooseDateRange,
    ListAllChoosenData,
    ChooseDataResearch,
    NavPlantsSidebar,
  },
  data() {
    return {
      currentPlant: '',
      currentPlantComponent: '',
      currentTabComponent: '',
      allCheckedPlantComponentDescriptions: [],
      dataForVisualize: [],
      safedFormData: {},
      maxDescriptions: 10,
      mobilePlantSelectorOpen: false,
    };
  },
  methods: {
    prepareDataForVisualize(data) {
      console.log('entry prepareDataForVisualize');
      this.dataForVisualize = data;
    },
    generateExcel() {
      console.log('entry generateExcel');
      var formData = this.safedFormData;
      formData.type_data = 'xlsx';
      apiClient
        .post(
          `/api/v1/organisations/${this.$store.getters.getOrganisation.id}/get_research_data/`,
          formData,
          { responseType: 'blob' }
        )
        .then((response) => {
          console.log('fertig');
          console.log(response.data);
          fileDownload(response.data, `_auswertung.xlsx`);
        })
        .catch((error) => {
          this.chartDone = true;
          if (error.response) {
            if ('detail' in error.response.data) {
              createToast({ text: this.$t(error.response.data['detail']), type: 'error' });
            }
            console.error(JSON.stringify(error.response.data));
          } else if (error.message) {
            console.error(JSON.stringify(error.message));
          } else {
            console.error(JSON.stringify(error));
          }
        });
      console.log('exit generateExcel');
    },
    confirmDate(dateObject, type) {
      console.log('entry confirmDate');
      console.log(dateObject);
      var formData = dateObject;
      formData.type_data = type;
      formData.selectionData = this.allCheckedPlantComponentDescriptions;
      this.safedFormData = formData;
      if (type === 'xlsx') {
        this.generateExcel();
        return;
      }
      apiClient
        .post(
          `/api/v1/organisations/${this.$store.getters.getOrganisation.id}/get_research_data/`,
          formData
        )
        .then((response) => {
          console.log('fertig');
          console.log(response.data);
          this.prepareDataForVisualize(response.data);
        })
        .catch((error) => {
          this.chartDone = true;
          if (error.response) {
            if ('detail' in error.response.data) {
              createToast({ text: this.$t(error.response.data['detail']), type: 'error' });
            }
            console.error(JSON.stringify(error.response.data));
          } else if (error.message) {
            console.error(JSON.stringify(error.message));
          } else {
            console.error(JSON.stringify(error));
          }
        });
      console.log('exit confirmDate');
    },
    removeDescription(description) {
      console.log('entry removeDescription');
      console.log(description);
      let pos_description = this.allCheckedPlantComponentDescriptions
        .map((e) => e.description_id)
        .indexOf(description.description_id);
      console.log(pos_description);
      if (pos_description != -1) {
        this.removeItemCheckedArray(pos_description);
      }
      console.log('exit removeDescription');
    },
    removeItemCheckedArray(pos_description) {
      console.log('entry removeItemCheckedArray');
      console.log(pos_description);
      this.allCheckedPlantComponentDescriptions.splice(pos_description, 1);
      console.log('remove removeItemCheckedArray');
    },
    addItemCheckedArray(description) {
      console.log('entry addItemCheckedArray');
      var plant_component_description = {};
      plant_component_description.plant_name = this.currentPlant.name;
      plant_component_description.plant_id = this.currentPlant.id;
      plant_component_description.component_name = this.currentPlantComponent.name;
      plant_component_description.component_id = this.currentPlantComponent.id;
      plant_component_description.description_name = description.col_description;
      plant_component_description.description_id = description.id;
      plant_component_description.col_component_data = description.col_component_data;

      this.allCheckedPlantComponentDescriptions.push(plant_component_description);
      console.log('exit addItemCheckedArray');
    },
    updateChoosenData(description) {
      console.log('entry updateChoosenData');
      let pos_description = this.allCheckedPlantComponentDescriptions
        .map((e) => e.description_id)
        .indexOf(description.id);

      if (pos_description == -1) {
        this.addItemCheckedArray(description);
      } else {
        this.removeItemCheckedArray(pos_description);
      }
      console.log('exit updateChoosenData');
    },
    onMobilePlantSelected(plant) {
      this.setResearchPlant(plant);
    },
    onMobileComponentSelected(plant, component) {
      this.mobilePlantSelectorOpen = false;
      this.setResearchPlantComponent(plant, component);
    },
    setResearchPlant(plant) {
      console.log('entry setResearchPlant');
      this.currentPlant = plant;
      this.currentPlantComponent = '';
      this.currentTabComponent = 'ResearchForPlant';
      console.log('exit setResearchPlant');
    },
    setResearchPlantComponent(plant, component) {
      console.log('entry ssetResearchPlantComponent');
      this.currentPlant = plant;
      this.currentPlantComponent = component;
      this.currentTabComponent = 'ResearchForPlant';
      console.log('exit setResearchPlantComponent');
    },
  },
  computed: {
    plantsLoaded() {
      if (this.$store.getters.getPlants) {
        return true;
      }
      return false;
    },
    organisation() {
      return this.$store.getters.getOrganisation;
    },

    currentProperties() {
      return {
        plant: this.currentPlant,
        component: this.currentPlantComponent,
        checkedDescriptions: this.allCheckedPlantComponentDescriptions,
        maxDescriptions: this.maxDescriptions,
      };
    },
    visualizeProperties() {
      return { dataForVisualize: this.dataForVisualize };
    },
    propertiesListChoosenData() {
      return {
        allCheckedPlantComponentDescriptions: this.allCheckedPlantComponentDescriptions,
        maxDescriptions: this.maxDescriptions,
      };
    },
    currentPlantsProperties() {
      return {
        plants: this.$store.getters.getPlants,
        showPlantComponents: true,
        editPlantComponents: false,
        editPlants: false,
      };
    },
  },
};
</script>

<style scoped>
/* iOS-style grouped list for mobile offcanvas */
.offcanvas-body {
  background-color: #f2f2f7;
  padding: 0 !important;
}

.offcanvas-body :deep(.nav-sidebar) {
  padding: 12px 16px;
  margin: 0;
}

/* Plant row — bold header item */
.offcanvas-body :deep(.nav-sidebar > .nav-item > .nav-link) {
  background: #fff;
  border-radius: 12px;
  padding: 14px 16px;
  color: #000;
  font-size: 17px;
  font-weight: 600;
  text-decoration: none;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.offcanvas-body :deep(.nav-sidebar > .nav-item > .nav-link::after) {
  content: '›';
  font-size: 20px;
  color: #c7c7cc;
  font-weight: 300;
  line-height: 1;
}
.offcanvas-body :deep(.nav-sidebar > .nav-item > .nav-link.active) {
  color: #007aff;
}

/* Sub-nav section inside collapsed plant */
.offcanvas-body :deep(.nav-sidebar .collapse > .nav.flex-column) {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 8px;
}

/* "Komponenten" section label */
.offcanvas-body :deep(.nav-sidebar .collapse > .nav > .nav-item > .nav-link) {
  padding: 10px 16px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #8e8e93;
  background: transparent;
  border-bottom: 0.5px solid #e5e5ea;
}
.offcanvas-body :deep(.nav-sidebar .collapse > .nav > .nav-item > .nav-link::after) {
  display: none;
}

/* Individual component rows */
.offcanvas-body :deep(.nav-sidebar .collapse .ps-3) {
  padding: 0 !important;
}
.offcanvas-body :deep(.nav-sidebar .collapse .ps-3 .nav-link) {
  padding: 14px 16px;
  font-size: 16px;
  font-weight: 400;
  color: #000;
  text-decoration: none;
  border-bottom: 0.5px solid #e5e5ea;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: transparent;
}
.offcanvas-body :deep(.nav-sidebar .collapse .ps-3 .nav-link::after) {
  content: '›';
  font-size: 20px;
  color: #c7c7cc;
  font-weight: 300;
  flex-shrink: 0;
}
.offcanvas-body :deep(.nav-sidebar .collapse .ps-3 .nav-item:last-child .nav-link) {
  border-bottom: none;
}
.offcanvas-body :deep(.nav-sidebar .collapse .ps-3 .nav-link.active) {
  color: #007aff;
  background-color: #f0f5ff;
}

/* Remove Bootstrap's offset/padding from sub-lists */
.offcanvas-body :deep(.nav-sidebar .offset-1) {
  margin-left: 0 !important;
}
</style>
